import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_ITINERARY_COUNTER_REPORTS,
  GET_ITINERARY_COUNTER_REPORTS,
  FLAG_ITINERARY_COUNTER_REPORT_ACTIVITY,
  GET_ITINERARY_COUNTER_REPORT,
  CLEAR_ITINERARY_COUNTER_REPORT,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_ITINERARY_COUNTER_REPORTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_ITINERARY_COUNTER_REPORTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case GET_ITINERARY_COUNTER_REPORT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_COUNTER_REPORT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_ITINERARY_COUNTER_REPORT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
